import type { CompleteSuccessStory } from '../../types';

interface HeroSectionProps {
  story: CompleteSuccessStory;
}

export function HeroSection({ story }: HeroSectionProps) {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/90 to-secondary text-primary-foreground overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <span className="text-xs font-mono uppercase tracking-wide">{story.industry}</span>
              <span className="w-1 h-1 bg-white/50 rounded-full"></span>
              <span className="text-xs font-mono uppercase tracking-wide">{story.companySize}</span>
            </div>
            <h1 className="font-bold text-4xl lg:text-6xl leading-tight mb-6">{story.headline}</h1>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">{story.summary}</p>
            <div className="flex flex-wrap gap-4">
              <button className="bg-accent text-accent-foreground px-8 py-4 rounded-lg font-semibold hover:opacity-90 transition-opacity shadow-xl">
                Download Full Case Study
              </button>
              <button className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors border border-white/20">
                Watch Video
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {story.impactMetrics.slice(0, 4).map((metric) => (
              <div
                key={metric.id}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:scale-105 transition-transform"
              >
                <div className="text-5xl font-bold mb-2 text-accent">{metric.metricValue}</div>
                <div className="text-sm text-white/80 uppercase tracking-wide font-medium">
                  {metric.metricLabel}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
